import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { UserState } from './states'

const AdsAccount: Module<UserState, State> = {
  state: new UserState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
